 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		207: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"tasks-task-helpers","1":"state-clone","2":"home-learning-group~tasks-associates~tasks-associates-components~tasks-associates-endrun~tasks-assoc~938a24c9","3":"home-learning-group~tasks-associates~tasks-associates-components~tasks-associates-endrun~tasks-assoc~91612b98","4":"tasks-seqgen-create-sequence~tasks-seqgen-klEvaluation~tasks-seqgen-sl-seq-data~tasks-seqgen-srt-seq~5b870df9","5":"tasks-associates-game~tasks-matrices-game~tasks-pal-game~tasks-pal-game-trial~tasks-reversal-game~ta~5422aad0","6":"tasks-associates-game~tasks-iowa-game~tasks-matrices-game~tasks-pal-game~tasks-pal-game-trial~tasks-~d780c5a0","7":"npm.country-list","8":"tasks-qn-response-types-response-mixin~tasks-qn-state-qstCategorical~tasks-qn-state-qstCountry~tasks~87ce9b12","9":"viewModel","10":"general-info~general-options~tasks-index-base~tasks-task-mixin","11":"tasks-iowa-endblock~tasks-iowa-game~tasks-iowa-game-card~tasks-iowa-state-state","12":"tasks-sequence-learning-endblock~tasks-sequence-learning-state-state~tasks-serialrt-endblock~tasks-s~3429d0c9","13":"tasks-qn-question~tasks-qn-response-types~tasks-qn-response-types-response-categorical","14":"tasks-qn-question~tasks-qn-response-types~tasks-qn-response-types-response-country","15":"tasks-qn-question~tasks-qn-response-types~tasks-qn-response-types-response-textbox","16":"login-my-utils","17":"tasks-index-base~tasks-task-continue~tasks-task-mixin","18":"tasks-qn-response-types-response-mixin~tasks-qn-state-question-factory~tasks-qn-state-state","19":"components-navbar2-html","20":"home-a2hs-html","22":"npm.jsonata","23":"points-points~tasks-endrun-base","24":"tasks-endrun-base~tasks-leaderboard","25":"tasks-index-base~tasks-task-mixin","26":"tasks-iowa-endblock~tasks-iowa-state-state","27":"tasks-iowa-game~tasks-iowa-game-card","28":"tasks-matrices-state-matrices-data~tasks-matrices-state-state","29":"tasks-pal-endblock~tasks-pal-state-state","30":"tasks-seqgen-sl-seq-data~tasks-seqgen-srt-seq-data","31":"tasks-sequence-learning-star-awards~tasks-star-awards","32":"about-about-html","33":"components-navbar-html","34":"general-info-html","35":"general-options-html","36":"help-help-html","37":"home-learning-group-html","38":"login-change-password-html","39":"login-login-html","40":"login-my-details-html","41":"login-reset-html","42":"login-sendreset-html","43":"points-points-html","44":"progression-selection-html","45":"progression-story-html","46":"tasks-associates","47":"tasks-iowa","48":"tasks-matrices","49":"tasks-pal","50":"tasks-qn","51":"tasks-qn-response-types","52":"tasks-reversal","53":"tasks-sequence-learning","54":"tasks-serialrt","55":"tasks-wisconsin","56":"about-about","57":"components-navbar","58":"components-navbar2","59":"components-onc-icon","60":"components-svg-icon","61":"components-theme","62":"general-info","63":"general-options","64":"help-help","65":"home-a2hs","66":"home-home","67":"home-learning-group","68":"home-main-page","69":"login-change-password","70":"login-login","71":"login-my-details","72":"login-reset","73":"login-sendreset","74":"points-points","75":"progression-selection","76":"progression-story","77":"tasks-associates-components","78":"tasks-associates-endrun","79":"tasks-associates-game","80":"tasks-associates-intro","81":"tasks-associates-state-data","82":"tasks-associates-state-helpers","83":"tasks-associates-state-state","84":"tasks-badge-map","85":"tasks-endrun-base","86":"tasks-index-base","87":"tasks-intro-base","88":"tasks-iowa-components","89":"tasks-iowa-endblock","90":"tasks-iowa-endrun","91":"tasks-iowa-game","92":"tasks-iowa-game-card","93":"tasks-iowa-intro","94":"tasks-iowa-state-helpers","95":"tasks-iowa-state-iowa-data","96":"tasks-iowa-state-state","97":"tasks-leaderboard","98":"tasks-matrices-components","99":"tasks-matrices-endrun","100":"tasks-matrices-game","101":"tasks-matrices-intro","102":"tasks-matrices-state-helpers","103":"tasks-matrices-state-matrices-data","104":"tasks-matrices-state-state","105":"tasks-matrices-state-stimuli-sets","106":"tasks-pal-components","107":"tasks-pal-endblock","108":"tasks-pal-endpractice","109":"tasks-pal-endrun","110":"tasks-pal-game","111":"tasks-pal-game-trial","112":"tasks-pal-intro","113":"tasks-pal-pal-data","114":"tasks-pal-state-data","115":"tasks-pal-state-helpers","116":"tasks-pal-state-state","117":"tasks-progress-bar","118":"tasks-qn-endrun","119":"tasks-qn-intro","120":"tasks-qn-jsonquery","121":"tasks-qn-question","122":"tasks-qn-questionnaire","123":"tasks-qn-response-types-response-categorical","124":"tasks-qn-response-types-response-country","125":"tasks-qn-response-types-response-mixin","126":"tasks-qn-response-types-response-textbox","127":"tasks-qn-state-data","128":"tasks-qn-state-helpers","129":"tasks-qn-state-qstCategorical","130":"tasks-qn-state-qstCountry","131":"tasks-qn-state-qstTextbox","132":"tasks-qn-state-question-base","133":"tasks-qn-state-question-factory","134":"tasks-qn-state-state","135":"tasks-reversal-components","136":"tasks-reversal-endrun","137":"tasks-reversal-game","138":"tasks-reversal-intro","139":"tasks-reversal-state-data","140":"tasks-reversal-state-helpers","141":"tasks-reversal-state-state","142":"tasks-seqgen-config","143":"tasks-seqgen-create-sequence","144":"tasks-seqgen-klEvaluation","145":"tasks-seqgen-sl-seq-data","146":"tasks-seqgen-srt-seq-data","147":"tasks-seqgen-util","148":"tasks-sequence-learning-components","149":"tasks-sequence-learning-endblock","150":"tasks-sequence-learning-endpractice","151":"tasks-sequence-learning-endrun","152":"tasks-sequence-learning-game","153":"tasks-sequence-learning-game-trial","154":"tasks-sequence-learning-intro","155":"tasks-sequence-learning-space-feedback","156":"tasks-sequence-learning-space-stimulus","157":"tasks-sequence-learning-star-awards","158":"tasks-sequence-learning-state-data","159":"tasks-sequence-learning-state-helpers","160":"tasks-sequence-learning-state-state","161":"tasks-serialrt-components","162":"tasks-serialrt-endblock","163":"tasks-serialrt-endpractice","164":"tasks-serialrt-endrun","165":"tasks-serialrt-game","166":"tasks-serialrt-game-trial","167":"tasks-serialrt-intro","168":"tasks-serialrt-state-data","169":"tasks-serialrt-state-helpers","170":"tasks-serialrt-state-state","171":"tasks-star-awards","172":"tasks-task-away","173":"tasks-task-continue","174":"tasks-task-data","175":"tasks-task-mixin","176":"tasks-taskbar","177":"tasks-wisconsin-components","178":"tasks-wisconsin-endrun","179":"tasks-wisconsin-game","180":"tasks-wisconsin-game-card","181":"tasks-wisconsin-intro","182":"tasks-wisconsin-state-card-utils","183":"tasks-wisconsin-state-data","184":"tasks-wisconsin-state-helpers","185":"tasks-wisconsin-state-state","186":"version","187":"home-home-html","206":"npm.workbox-window","208":"tasks-associates-endrun-html","209":"tasks-associates-game-html","210":"tasks-associates-intro-html","211":"tasks-endrun-base-html","212":"tasks-intro-base-html","213":"tasks-iowa-endblock-html","214":"tasks-iowa-game-card-html","215":"tasks-iowa-game-html","216":"tasks-leaderboard-html","217":"tasks-matrices-endrun-html","218":"tasks-matrices-game-html","219":"tasks-pal-endblock-html","220":"tasks-pal-endpractice-html","221":"tasks-pal-game-html","222":"tasks-pal-game-trial-html","223":"tasks-pal-intro-html","224":"tasks-qn-endrun-html","225":"tasks-qn-index-html","226":"tasks-qn-intro-html","227":"tasks-qn-question-html","228":"tasks-qn-questionnaire-html","229":"tasks-qn-response-types-response-categorical-html","230":"tasks-qn-response-types-response-country-html","231":"tasks-qn-response-types-response-textbox-html","232":"tasks-reversal-game-html","233":"tasks-sequence-learning-endblock-html","234":"tasks-sequence-learning-endpractice-html","235":"tasks-sequence-learning-game-html","236":"tasks-sequence-learning-game-trial-html","237":"tasks-sequence-learning-intro-html","238":"tasks-sequence-learning-space-feedback-html","239":"tasks-sequence-learning-space-stimulus-html","240":"tasks-serialrt-endblock-html","241":"tasks-serialrt-endpractice-html","242":"tasks-serialrt-game-html","243":"tasks-serialrt-game-trial-html","244":"tasks-serialrt-intro-html","245":"tasks-star-awards-html","246":"tasks-task-away-html","247":"tasks-task-continue-html","248":"tasks-taskbar-html","249":"tasks-wisconsin-endrun-html","250":"tasks-wisconsin-game-html"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/client/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
